import FormControl from "@mui/material/FormControl";
import { FormControlLabel, Radio, RadioGroup, Tooltip } from "@mui/material";
import Typography from "@mui/material/Typography";
import * as React from "react";

const TemplateRadioGroup = ({
    id,
    value,
    setValue,
    options,
}: {
    id: string;
    value: string;
    setValue: React.Dispatch<React.SetStateAction<string>>;
    options: { name: string; value: string; tooltip?: string }[];
}) => {
    const handleSelectionChange = (_e: React.ChangeEvent<HTMLInputElement>, v: string) => {
        setValue(v);
        localStorage.setItem(id, v);
    };
    return (
        <FormControl>
            <RadioGroup
                aria-labelledby="demo-controlled-radio-buttons-group"
                name="controlled-radio-buttons-group"
                value={value}
                onChange={handleSelectionChange}
                onClick={(e) => e.stopPropagation()}
                row
            >
                {options.map((option) => (
                    <Tooltip title={option.tooltip}>
                        <FormControlLabel
                            value={option.value}
                            control={<Radio size="small" />}
                            label={<Typography sx={{ fontSize: 12 }}>{option.name}</Typography>}
                        />
                    </Tooltip>
                ))}
            </RadioGroup>
        </FormControl>
    );
};

export default TemplateRadioGroup;
